angular.module('lf.desktop')

.factory('scrolls', function () {
  
  var scrolls = {};

  return {
    register: angular.noop,
    get: angular.noop,
    unregister: angular.noop,
    scrollTop: angular.noop
  }

});
